import React from "react";
import { isSameDay, isSameMonth } from "date-fns";
import { DEMO_CALL_COPY } from "./demoCallContent.js";
import {
  calendarWeeks,
  dayKey,
  formatDayLabel,
  formatMonthLabel,
  isMonthReachable,
  isSelectableDate,
  shiftMonth,
} from "./demoCallSchedule.js";

const DemoCallCalendar = ({
  visibleMonth,
  selectedDate,
  now,
  timeZone,
  onSelectDate,
  onShiftMonth,
}) => {
  const weeks = calendarWeeks(visibleMonth);
  const canGoBack = isMonthReachable(shiftMonth(visibleMonth, -1), now, timeZone);
  const canGoForward = isMonthReachable(shiftMonth(visibleMonth, 1), now, timeZone);

  return (
    <div>
      <div className="quiet-demo-month-bar">
        <button
          type="button"
          className="quiet-demo-month-nav"
          aria-label={DEMO_CALL_COPY.prevMonth}
          onClick={() => onShiftMonth(-1)}
          disabled={!canGoBack}
        >
          ‹
        </button>
        <span className="quiet-demo-month-label">{formatMonthLabel(visibleMonth)}</span>
        <button
          type="button"
          className="quiet-demo-month-nav"
          aria-label={DEMO_CALL_COPY.nextMonth}
          onClick={() => onShiftMonth(1)}
          disabled={!canGoForward}
        >
          ›
        </button>
      </div>
      <div role="grid" aria-label={DEMO_CALL_COPY.calendarLabel}>
        <div className="quiet-demo-weekdays" role="row">
          {DEMO_CALL_COPY.weekdays.map((label) => (
            <span key={label} className="quiet-demo-weekday" role="columnheader">
              {label}
            </span>
          ))}
        </div>
        {weeks.map((week) => (
          <div className="quiet-demo-week" role="row" key={dayKey(week[0])}>
            {week.map((day) => {
              const outside = !isSameMonth(day, visibleMonth);
              const selectable = !outside && isSelectableDate(day, now, timeZone);
              const selected = selectedDate ? isSameDay(day, selectedDate) : false;

              return (
                <div
                  key={dayKey(day)}
                  role="gridcell"
                  aria-selected={selected}
                  className={outside ? "quiet-demo-day-outside" : undefined}
                >
                  <button
                    type="button"
                    className={selected ? "quiet-demo-day quiet-demo-day-selected" : "quiet-demo-day"}
                    aria-label={formatDayLabel(day)}
                    aria-hidden={outside || undefined}
                    disabled={!selectable}
                    data-testid={`demo-day-${dayKey(day)}`}
                    onClick={() => onSelectDate(day)}
                  >
                    {day.getDate()}
                  </button>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DemoCallCalendar;
